import { ToggleGroup, ToggleGroupOption } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { ItemPriority } from '@retail/products/types';
import { useMemo } from 'react';
interface Props {
  selectedPriority: ItemPriority;
  setPriority: (prio: ItemPriority) => void;
}

export function SupplierPriorityToggleGroup({ selectedPriority, setPriority }: Props) {
  const t = useMyAssortmentTFunction();

  const priorityOptions: ToggleGroupOption<ItemPriority.ZERO | ItemPriority.TEN>[] = useMemo(
    () => [
      { label: t('myAssortment.priority.mainPrioSupplier'), value: ItemPriority.ZERO },
      { label: t('myAssortment.priority.underPrioSupplier'), value: ItemPriority.TEN },
    ],
    [t]
  );
  return (
    <ToggleGroup
      label={t('myAssortment.status.inAssortment')}
      labelVariant="body1"
      labelDirection="vertical"
      size="small"
      fullWidth
      options={priorityOptions}
      value={selectedPriority}
      onChange={setPriority}
    />
  );
}
